import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from './components/layout/Layout'
import { ProtectedRoute } from './components/layout/ProtectedRoute'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import BusinessList from './pages/businesses/BusinessList'
import BusinessForm from './pages/businesses/BusinessForm'
import BusinessImages from './pages/businesses/BusinessImages'
import CategoryList from './pages/categories/CategoryList'
import CategoryForm from './pages/categories/CategoryForm'
import ServiceList from './pages/services/ServiceList'
import ServiceForm from './pages/services/ServiceForm'
import PricingList from './pages/pricing/PricingList'
import PricingForm from './pages/pricing/PricingForm'
import FaqList from './pages/faq/FaqList'
import FaqForm from './pages/faq/FaqForm'
import Contact from './pages/Contact'
import LocationList from './pages/locations/LocationList'
import LocationForm from './pages/locations/LocationForm'
import Users from './pages/Users'
import Roles from './pages/Roles'
import Settings from './pages/Settings'

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={<ProtectedRoute />}>
          <Route element={<Layout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/businesses" element={<BusinessList />} />
            <Route path="/businesses/new" element={<BusinessForm />} />
            <Route path="/businesses/:id/edit" element={<BusinessForm />} />
            <Route path="/businesses/:id/images" element={<BusinessImages />} />
            <Route path="/categories" element={<CategoryList />} />
            <Route path="/categories/new" element={<CategoryForm />} />
            <Route path="/categories/:id/edit" element={<CategoryForm />} />
            <Route path="/services" element={<ServiceList />} />
            <Route path="/services/new" element={<ServiceForm />} />
            <Route path="/services/:id/edit" element={<ServiceForm />} />
            <Route path="/pricing" element={<PricingList />} />
            <Route path="/pricing/new" element={<PricingForm />} />
            <Route path="/pricing/:id/edit" element={<PricingForm />} />
            <Route path="/faq" element={<FaqList />} />
            <Route path="/faq/new" element={<FaqForm />} />
            <Route path="/faq/:id/edit" element={<FaqForm />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/locations" element={<LocationList />} />
            <Route path="/locations/new" element={<LocationForm />} />
            <Route path="/users" element={<Users />} />
            <Route path="/roles" element={<Roles />} />
            <Route path="/settings" element={<Settings />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}
